import { render, staticRenderFns } from "./PostBody.vue?vue&type=template&id=2274764c&scoped=true"
import script from "./PostBody.vue?vue&type=script&lang=js"
export * from "./PostBody.vue?vue&type=script&lang=js"
import style0 from "./PostBody.vue?vue&type=style&index=0&id=2274764c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2274764c",
  null
  
)

export default component.exports